module.exports = __webpack_public_path__ + "img/news_01.feb0c97a.jpg";